// TODO
export function QuizPlayedAlreadyWarning(): JSX.Element {
  return <>Nope, you have played today already</>;
}
